import { useTranslation } from "@sagot/i18n";
import { Badge, Icon } from "@sagot/ui";
import { useFormatters } from "../shared/format";
import { snoozeEnd, snoozeWhen } from "./snooze";
import type { ConversationItem } from "./inbox-model";

/** "Snoozed until 3:00 PM": clock icon + words (never colour alone), in the workspace time zone; nothing once the snooze is over. */
export function SnoozeChip({ item, now }: { item: Pick<ConversationItem, "snoozed_until">; now: number }) {
  const { t } = useTranslation();
  const fmt = useFormatters();
  const until = snoozeEnd(item, now);
  if (!until) return null;
  const when = snoozeWhen(until, now, fmt);
  return (
    <Badge tone="neutral" title={fmt.dateTime(until)} data-testid="snooze-chip">
      <Icon name="clock" className="size-3" />
      {t("engage.inbox.snooze.until", { when })}
    </Badge>
  );
}
